export const GENOMIC_LIFE_COMPLETE_MEMBER_INTRO =
  "The three-in-one membership uses the power of your DNA to reveal your personal health risks—and provides one-on-one support to help you stay healthy. If a serious illness like cancer still strikes, get dedicated support to help you access timely, quality care.";

export const GENOMIC_LIFE_COMPLETE_GIFT_RECIPIENT_INTRO =
  "The three-in-one membership uses the power of a person’s DNA to reveal their personal health risks—and provides one-on-one support to help them stay healthy. If a serious illness like cancer still strikes, they get dedicated support to help them access timely, quality care.";

export type GenomicLifeCompleteFeatureLine = {
  label: string;
  body: string;
};

export const GENOMIC_LIFE_COMPLETE_MEMBER_FEATURES: readonly GenomicLifeCompleteFeatureLine[] =
  [
    {
      label: "DNA Screenings:",
      body: "By looking at your DNA, it’s possible to uncover your personal risk of developing a serious illness—so your doctors can act early and help you stay healthy."
    },
    {
      label: "Personalized Health Guidance:",
      body: "Our team can help you understand your results and take action. Plus, if you hit a roadblock with your healthcare, our team can help you get back on track. "
    },
    {
      label: "Cancer Navigation:",
      body: "If you are diagnosed with cancer, Genomic Life works alongside your doctors to help you fully understand treatment options and overcome barriers—so you can feel confident in your next steps. "
    }
  ];

export const GENOMIC_LIFE_COMPLETE_GIFT_RECIPIENT_FEATURES: readonly GenomicLifeCompleteFeatureLine[] =
  [
    {
      label: "DNA Screenings:",
      body: "By looking at a person’s DNA, it’s possible to uncover their personal risk of developing a serious illness—so their doctors can act early and help them stay healthy."
    },
    {
      label: "Personalized Health Guidance:",
      body: "Our team helps members understand their results and take action. Plus, if a member hits a roadblock with their healthcare, our team can help them get back on track. "
    },
    {
      label: "Cancer Navigation:",
      body: "If a member is diagnosed with cancer, Genomic Life works alongside their doctors to help them fully understand treatment options and overcome barriers—so they can feel confident in their next steps. "
    }
  ];
